const messages = {
    Austria: 'footer.countryPicker.austria',
    France: 'footer.countryPicker.france',
    Germany: 'footer.countryPicker.germany',
    Ireland: 'footer.countryPicker.ireland',
    Netherlands: 'footer.countryPicker.netherlands',
    Spain: 'footer.countryPicker.spain',
    UnitedKingdom: 'footer.countryPicker.unitedKingdom',
    UnitedStates: 'footer.countryPicker.unitedStates',
    EU: 'footer.countryPicker.eu',
    Poland: 'footer.countryPicker.poland',
    Finland: 'footer.countryPicker.finland',
};
export default messages;
//# sourceMappingURL=messages.js.map